var SharedSpinnerView, SupportCMSModel, SupportFinePrintView, SupportFlashView, SupportInbentaModel, SupportUtilsHelper;

SupportFlashView = require('../views/flash_view');

SupportFinePrintView = require('../views/order_related/fine_print_view');

SupportCMSModel = require('../models/CMS');

SupportInbentaModel = require('../models/Inbenta');

SharedSpinnerView = require('../../../shared/frontend/views/spinner_view');

SupportUtilsHelper = {
  delay: function(ms, func) {
    return setTimeout(func, ms);
  },
  flash: function(type, content, sticky) {
    var view;
    if (sticky == null) {
      sticky = false;
    }
    view = new SupportFlashView({
      type: type,
      content: content,
      sticky: sticky
    });
    view.render();
    return $('#flash_container').html(view.$el);
  },
  highlight: function($element, callback, className) {
    if (className == null) {
      className = 'flash_highlight';
    }
    $element.addClass(className);
    return delay(Groupon.Support.DELAY_TIMES.flash, function() {
      $element.removeClass(className);
      if (callback) {
        return callback();
      }
    });
  },
  highlightText: function($element, callback) {
    $element.addClass('flash_text');
    return delay(Groupon.Support.DELAY_TIMES.flash, function() {
      $element.removeClass('flash_text');
      if (callback) {
        return callback();
      }
    });
  },
  openLocation: function(url) {
    return window.open(url);
  },
  isFileUploadSupported: function() {
    return window.FileReader != null;
  },
  showLoading: function(div, height) {
    var hash, spinner;
    if (height == null) {
      height = "250px";
    }
    if ($(".g-spinner", div).length === 0) {
      div.empty();
      spinner = new SharedSpinnerView();
      hash = {
        container: div,
        id: "g-spinner",
        height: height
      };
      return spinner.show(hash);
    }
  },
  openLinksInNewTab: function(div_links) {
    return div_links.attr("target", "_blank");
  },
  replaceNewLineWithBreak: function(text) {
    return text != null ? text.replace(/\n|\\x0a/gi, '<br />') : void 0;
  },
  renderFinePrint: function() {
    var finePrintView;
    finePrintView = new SupportFinePrintView();
    return finePrintView.render();
  },
  textOverflowEllipsis: function(length) {
    return function() {
      return function(text, render) {
        var content, delimitedContent;
        content = render(text);
        content = content.trim();
        if (content.length > length) {
          delimitedContent = content.substring(0, length - 3) + '...';
          return '<span title="' + content + '">' + delimitedContent + '</span>';
        } else {
          return content;
        }
      };
    };
  },
  addToTrackingHub: function(c, sc) {
    var data;
    data = {
      category: c,
      subcategory: sc
    };
    return TrackingHub.add("support-app-user-dropdown-change", {
      data: data
    });
  },
  activateieHacks: function() {
    ieISODateStringHack();
    return ieStringTrimHack();
  },
  ieISODateStringHack: function() {
    if (!Date.prototype.toISOString) {
      if (!Date.prototype.toJSON) {
        Date.prototype.toJSON = function(key) {
          var f;
          f = function(n) {};
          if (n < 10) {
            "0" + n;
          } else {
            n;
          }
          return this.getUTCFullYear() + "-" + f(this.getUTCMonth() + 1) + "-" + f(this.getUTCDate()) + "T" + f(this.getUTCHours()) + ":" + f(this.getUTCMinutes()) + ":" + f(this.getUTCSeconds()) + "Z";
        };
      }
      return Date.prototype.toISOString = Date.prototype.toJSON;
    }
  },
  ieStringTrimHack: function() {
    if (typeof String.prototype.trim !== 'function') {
      return String.prototype.trim = function() {
        return this.replace(/^\s+|\s+$/g, '');
      };
    }
  },
  isUserLogged: function() {
    if (typeof currentUser !== "undefined" && currentUser !== null) {
      return true;
    } else {
      return false;
    }
  },
  match: function(arg1, arg2) {
    var diff, split1, split2;
    split1 = arg1 != null ? arg1.split(";") : void 0;
    split2 = arg2 != null ? arg2.split(";") : void 0;
    diff = _.difference(split1, split2);
    return diff.length === 0;
  },
  addParameterToUrlConsideringTheHash: function(url, parameterName, parameterValue, atStart) {
    var cl, i, newQueryString, parameterParts, parameters, replaceDuplicates, sourceUrl, urlParts, urlhash;
    replaceDuplicates = true;
    if (url.indexOf("#") > 0) {
      cl = url.indexOf("#");
      urlhash = url.substring(url.indexOf("#"), url.length);
    } else {
      urlhash = "";
      cl = url.length;
    }
    sourceUrl = url.substring(0, cl);
    urlParts = sourceUrl.split("?");
    newQueryString = "";
    if (urlParts.length > 1) {
      parameters = urlParts[1].split("&");
      i = 0;
      while (i < parameters.length) {
        parameterParts = parameters[i].split("=");
        if (!(replaceDuplicates && parameterParts[0] === parameterName)) {
          if (newQueryString === "") {
            newQueryString = "?";
          } else {
            newQueryString += "&";
          }
          newQueryString += parameterParts[0] + "=" + (parameterParts[1] ? parameterParts[1] : "");
        }
        i++;
      }
    }
    if (newQueryString === "") {
      newQueryString = "?";
    }
    if (atStart) {
      newQueryString = "?" + parameterName + "=" + parameterValue + (newQueryString.length > 1 ? "&" + newQueryString.substring(1) : "");
    } else {
      if (newQueryString !== "" && newQueryString !== "?") {
        newQueryString += "&";
      }
      newQueryString += parameterName + "=" + (parameterValue ? parameterValue : "");
    }
    return urlParts[0] + newQueryString + urlhash;
  },
  getURLParameter: function(name) {
    return decodeURI((RegExp(name + "=" + "(.+?)(&|$)").exec(location.search) || [null, null])[1]);
  },
  isCurrentOrderMarketRateDeal: function() {
    return this.isCurrentOrderOfDealType("GETAWAYS_MARKET_RATE");
  },
  isCurrentOrderGetawaysTonightDeal: function() {
    return this.isCurrentOrderOfDealType("GETAWAYS_TONIGHT");
  },
  isCurrentOrderGetawaysBookingDeal: function() {
    return this.isCurrentOrderOfDealType("GETAWAYS_BOOKING");
  },
  isCurrentOrderGetawaysVoucherDeal: function() {
    return this.isCurrentOrderOfDealType("GETAWAYS_VOUCHER");
  },
  isCurrentOrderGoodsDeal: function() {
    return this.isCurrentOrderGoodsShippingDeal() || this.isCurrentOrderGoodsVoucherDeal();
  },
  isCurrentOrderGoodsShippingDeal: function() {
    return this.isCurrentOrderOfDealType("GOODS_SHIPPING");
  },
  isCurrentOrderGoodsVoucherDeal: function() {
    return this.isCurrentOrderOfDealType("GOODS_VOUCHER");
  },
  isCurrentOrderLiveDeal: function() {
    return this.isCurrentOrderOfDealType("LIVE");
  },
  isCurrentOrderLocalDeal: function() {
    return this.isCurrentOrderOfDealType("LOCAL");
  },
  isCurrentOrderOfDealType: function(deal_type) {
    var ref;
    return ((ref = Groupon.Support.currentOrder) != null ? ref.DEAL_TYPE : void 0) === deal_type;
  },
  isCurrentOrderEditable: function() {
    var ref;
    return ((ref = Groupon.Support.currentOrder) != null ? ref.editable : void 0) === true;
  },
  isOrderPurchasedWithinHours: function(specifiedHours) {
    var ref;
    return ((ref = Groupon.Support.currentOrder) != null ? ref.hoursAfterPurchase : void 0) < specifiedHours;
  },
  isCurrentOrderGetawaysDeal: function() {
    return isCurrentOrderMarketRateDeal() || isCurrentOrderGetawaysTonightDeal() || isCurrentOrderGetawaysBookingDeal() || isCurrentOrderGetawaysVoucherDeal();
  },
  isCostcoDeal: function() {
    var ref, ref1;
    return window.isFromCostcoFaq || ((ref = Groupon.Support.ContentModel) != null ? ref.isCostcoDropdownCombination : void 0) || ((ref1 = Groupon.Support.currentOrder) != null ? ref1.isCostcoDeal : void 0);
  },
  checkIfCategoryIsAboutEditingOrCancelling: function() {
    return checkIfCategoryIdMatches("editing_or_canceling_an_order");
  },
  checkIfCategoryIdMatches: function(categoryId) {
    var ref;
    return ((ref = Groupon.Support.ContentModel.getCategory()) != null ? ref.id : void 0) === categoryId;
  },
  getCurrentUserFullName: function() {
    if (typeof currentUser !== "undefined" && currentUser !== null) {
      return (($.trim(currentUser.firstName)) + " " + ($.trim(currentUser.lastName))).trim();
    }
  },
  addMetaDataQueryParams: function(url) {
    url = SupportUtilsHelper.addInventoryServiceIdInQueryParams(url);
    url = SupportUtilsHelper.addCostcoDealInfoInQueryParams(url);
    return url;
  },
  addCostcoDealInfoInQueryParams: function(url) {
    var is_costco_deal;
    is_costco_deal = this.isCostcoDeal();
    if (is_costco_deal) {
      url = url + "&is_costco_deal=" + is_costco_deal;
    }
    return url;
  },
  addInventoryServiceIdInQueryParams: function(url) {
    var inventory_service_id, ref;
    inventory_service_id = (ref = Groupon.Support.currentOrder) != null ? ref.inventoryServiceId : void 0;
    if (inventory_service_id) {
      url = url + "&inventory_service_id=" + inventory_service_id;
    }
    return url;
  },
  setTrackingInformation: function(type, url) {
    TrackingHub.page.metadata.type = type;
    return OptimizeSuite.treatAsNewPage(url);
  },
  getMillisecondsOfUTCDateFromISOStringDate: function(ISOStringDate) {
    var base;
    base = 10;
    return Date.UTC(parseInt(ISOStringDate.substring(0, 4), base), parseInt(ISOStringDate.substring(5, 7), base) - 1, parseInt(ISOStringDate.substring(8, 10), base), parseInt(ISOStringDate.substring(11, 13), base), parseInt(ISOStringDate.substring(14, 16), base));
  },
  redirectToFaqHack: function() {
    var hash;
    hash = window.location.hash;
    if (hash.indexOf("#faqs:") > -1) {
      return window.location.assign("/faq" + hash);
    }
  },
  hideFloatingBoldChat: function() {
    var floatingChatElement;
    floatingChatElement = $('.bcFloat');
    if ((floatingChatElement != null ? floatingChatElement.length : void 0) > 0) {
      floatingChatElement.hide();
      return floatingChatElement.children().hide();
    }
  },
  showFloatingBoldChat: function() {
    var floatingChatElement;
    floatingChatElement = $('.bcFloat');
    if ((floatingChatElement != null ? floatingChatElement.length : void 0) > 0) {
      floatingChatElement.show();
      return floatingChatElement.children().show();
    }
  },
  getDealMerchantName: function() {
    var ref, ref1, reservationSource;
    if (isCurrentOrderMarketRateDeal() || isCurrentOrderGetawaysTonightDeal() || (isCurrentOrderGetawaysBookingDeal() && isIntl())) {
      reservationSource = this.getReservationSource(Groupon.Support.currentOrder);
      return reservationSource != null ? reservationSource.hotelName : void 0;
    } else {
      return (ref = Groupon.Support.currentOrder) != null ? (ref1 = ref.merchant) != null ? ref1.name : void 0 : void 0;
    }
  },
  isStaticLiveChat: function(mode) {
    return mode === 'static';
  },
  isBothLiveChats: function(mode) {
    return mode === 'both';
  },
  isFloatingLiveChat: function(mode) {
    return mode === 'floating';
  },
  getOrderInfoForBH: function(order) {
    var hash, ref;
    hash = {
      id: order != null ? order.id : void 0,
      country: window.country.name,
      dealId: order != null ? (ref = order.deal) != null ? ref.id : void 0 : void 0,
      channel: order != null ? order.DEAL_TYPE : void 0
    };
    if (window.showRedesign()) {
      hash.showActionButtonAsLinks = true;
    }
    return hash;
  },
  showRedesign: function() {
    var ref;
    return Groupon.Support.FeatureFlagModel.isRedesignOrdersUSEnabled() || window.evaluate((ref = window.experiments) != null ? ref.showVerticalPageFlow : void 0);
  },
  priorityViewsEnabled: function() {
    var ref, ref1;
    return ((ref = Groupon.Support.ContentModel) != null ? ref.isRefundEligible : void 0) || ((ref1 = Groupon.Support.ContentModel) != null ? ref1.escalateToMerchant : void 0);
  },
  liveChatVisible: function(liveChatDOMElem) {
    var clearImgurl;
    clearImgurl = /images.boldchat.com\/images\/clear/;
    return (liveChatDOMElem != null) && !(_.isEmpty(liveChatDOMElem.attr('src'))) && !clearImgurl.test(liveChatDOMElem.attr('src'));
  },
  setLiveChatDisplayCallBack: function(liveChatDOMElem, liveChatDisplayCallback) {
    if (((liveChatDOMElem != null ? liveChatDOMElem[0] : void 0) != null) && !window.liveChatCallBackSet) {
      window.liveChatCallBackSet = true;
      return liveChatDOMElem.on('load', function() {
        return liveChatDisplayCallback();
      });
    } else if ((liveChatDOMElem != null ? liveChatDOMElem[0] : void 0) == null) {
      return window.liveChatCallBackSet = false;
    }
  },
  liveChatLinkVisible: function() {
    var liveChatImageElem;
    liveChatImageElem = $("#live-chat-link-container div a div");
    return !_.isEmpty(liveChatImageElem.text());
  },
  getReservationSource: function(currentOrder) {
    var ref;
    return (currentOrder != null ? currentOrder.reservation : void 0) || (currentOrder != null ? (ref = currentOrder.travelBookingInfo) != null ? ref.reservation : void 0 : void 0);
  },
  findGrouponQuantity: function(groupons) {
    var quantity;
    quantity = 0;
    if (groupons != null) {
      _.each(groupons, function(groupon) {
        if (groupon.availability) {
          if (groupon.availability.toLowerCase() !== 'refunded') {
            return quantity++;
          }
        }
      });
    }
    return quantity;
  },
  shouldShowOptimizedChannel: function() {
    return evaluate(typeof experiments !== "undefined" && experiments !== null ? experiments.showOptimizedContactChannel : void 0) && !window.priorityViewsEnabled();
  },
  shouldShowFlexibleChannel: function() {
    return evaluate(typeof experiments !== "undefined" && experiments !== null ? experiments.showFlexibleContactChannels : void 0) && !window.priorityViewsEnabled();
  },
  hideFooterLinks: function() {
    return window.hideDOMElems($("#footer_dynamic_links"));
  },
  showFooterLinks: function() {
    return window.showDOMElems($("#footer_dynamic_links"));
  },
  shouldShowFlexibleFormsForUS: function() {
    return window.evaluate(experiments.shouldEnableFlexibleFormForUSWebFromCMS) && Groupon.Support.FeatureFlagModel.isShowFlexibleFormsForUSEnabled();
  },
  isCostcoDropdownCombination: function() {
    var category, costcoCategory, costcoSubcategory, ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, subCategory;
    category = ((ref = Groupon.Support.ContentModel.getCategory()) != null ? (ref1 = ref.id) != null ? ref1.toLowerCase() : void 0 : void 0) || null;
    subCategory = ((ref2 = Groupon.Support.ContentModel.getSubCategory()) != null ? (ref3 = ref2.id) != null ? ref3.toLowerCase() : void 0 : void 0) || null;
    costcoCategory = ((ref4 = window.costcoDropdowns) != null ? (ref5 = ref4.category) != null ? ref5.toLowerCase() : void 0 : void 0) || null;
    costcoSubcategory = ((ref6 = window.costcoDropdowns) != null ? (ref7 = ref6.subcategory) != null ? ref7.toLowerCase() : void 0 : void 0) || null;
    return (category != null) && (category.indexOf(costcoCategory) > -1) && (subCategory != null) && (subCategory.indexOf(costcoSubcategory) > -1);
  }
};

module.exports = SupportUtilsHelper;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUva3VtYXJyYS9uYXBpc3RyYW5vL2J1aWxkLzE1MDQ3NzgxNDM1MjYtNzYxNzcvcHJvZHVjdGlvbi0yMDE3LjA5LjA3XzA5LjU0L3N1cHBvcnRfYXBwL21vZHVsZXMvc3VwcG9ydC9mcm9udGVuZC9oZWxwZXJzL3V0aWxzLmNvZmZlZSIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi92YXIvZ3JvdXBvbi9ob21lL2t1bWFycmEvbmFwaXN0cmFuby9idWlsZC8xNTA0Nzc4MTQzNTI2LTc2MTc3L3Byb2R1Y3Rpb24tMjAxNy4wOS4wN18wOS41NC9zdXBwb3J0X2FwcC9tb2R1bGVzL3N1cHBvcnQvZnJvbnRlbmQvaGVscGVycy91dGlscy5jb2ZmZWUiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsSUFBQTs7QUFBQSxnQkFBQSxHQUFtQixPQUFBLENBQVEscUJBQVI7O0FBQ25CLG9CQUFBLEdBQXVCLE9BQUEsQ0FBUSx3Q0FBUjs7QUFDdkIsZUFBQSxHQUFrQixPQUFBLENBQVEsZUFBUjs7QUFDbEIsbUJBQUEsR0FBc0IsT0FBQSxDQUFRLG1CQUFSOztBQUN0QixpQkFBQSxHQUFvQixPQUFBLENBQVEsNkNBQVI7O0FBRXBCLGtCQUFBLEdBQ0U7RUFBQSxLQUFBLEVBQU8sU0FBQyxFQUFELEVBQUssSUFBTDtXQUNMLFVBQUEsQ0FBVyxJQUFYLEVBQWlCLEVBQWpCO0VBREssQ0FBUDtFQUdBLEtBQUEsRUFBTyxTQUFDLElBQUQsRUFBTyxPQUFQLEVBQWdCLE1BQWhCO0FBQ0wsUUFBQTs7TUFEcUIsU0FBUzs7SUFDOUIsSUFBQSxHQUFPLElBQUksZ0JBQUosQ0FDTDtNQUFBLElBQUEsRUFBTSxJQUFOO01BQ0EsT0FBQSxFQUFTLE9BRFQ7TUFFQSxNQUFBLEVBQVEsTUFGUjtLQURLO0lBSVAsSUFBSSxDQUFDLE1BQUwsQ0FBQTtXQUNBLENBQUEsQ0FBRSxrQkFBRixDQUFxQixDQUFDLElBQXRCLENBQTJCLElBQUksQ0FBQyxHQUFoQztFQU5LLENBSFA7RUFXQSxTQUFBLEVBQVcsU0FBQyxRQUFELEVBQVcsUUFBWCxFQUFxQixTQUFyQjs7TUFBcUIsWUFBWTs7SUFDMUMsUUFBUSxDQUFDLFFBQVQsQ0FBa0IsU0FBbEI7V0FDQSxLQUFBLENBQU0sT0FBTyxDQUFDLE9BQU8sQ0FBQyxXQUFXLENBQUMsS0FBbEMsRUFBeUMsU0FBQTtNQUN2QyxRQUFRLENBQUMsV0FBVCxDQUFxQixTQUFyQjtNQUNBLElBQWMsUUFBZDtlQUFBLFFBQUEsQ0FBQSxFQUFBOztJQUZ1QyxDQUF6QztFQUZTLENBWFg7RUFpQkEsYUFBQSxFQUFlLFNBQUMsUUFBRCxFQUFXLFFBQVg7SUFDYixRQUFRLENBQUMsUUFBVCxDQUFrQixZQUFsQjtXQUNBLEtBQUEsQ0FBTSxPQUFPLENBQUMsT0FBTyxDQUFDLFdBQVcsQ0FBQyxLQUFsQyxFQUF5QyxTQUFBO01BQ3ZDLFFBQVEsQ0FBQyxXQUFULENBQXFCLFlBQXJCO01BQ0EsSUFBYyxRQUFkO2VBQUEsUUFBQSxDQUFBLEVBQUE7O0lBRnVDLENBQXpDO0VBRmEsQ0FqQmY7RUF1QkEsWUFBQSxFQUFjLFNBQUMsR0FBRDtXQUNaLE1BQU0sQ0FBQyxJQUFQLENBQVksR0FBWjtFQURZLENBdkJkO0VBMEJBLHFCQUFBLEVBQXVCLFNBQUE7V0FDckI7RUFEcUIsQ0ExQnZCO0VBNkJBLFdBQUEsRUFBYSxTQUFDLEdBQUQsRUFBTSxNQUFOO0FBQ1gsUUFBQTs7TUFEaUIsU0FBUzs7SUFDMUIsSUFBRyxDQUFBLENBQUUsWUFBRixFQUFnQixHQUFoQixDQUFvQixDQUFDLE1BQXJCLEtBQStCLENBQWxDO01BQ0UsR0FBRyxDQUFDLEtBQUosQ0FBQTtNQUNBLE9BQUEsR0FBVSxJQUFJLGlCQUFKLENBQUE7TUFDVixJQUFBLEdBQ0U7UUFBQSxTQUFBLEVBQVcsR0FBWDtRQUNBLEVBQUEsRUFBSSxXQURKO1FBRUEsTUFBQSxFQUFRLE1BRlI7O2FBR0YsT0FBTyxDQUFDLElBQVIsQ0FBYSxJQUFiLEVBUEY7O0VBRFcsQ0E3QmI7RUF1Q0EsaUJBQUEsRUFBbUIsU0FBQyxTQUFEO1dBQ2pCLFNBQVMsQ0FBQyxJQUFWLENBQWUsUUFBZixFQUF3QixRQUF4QjtFQURpQixDQXZDbkI7RUEwQ0EsdUJBQUEsRUFBeUIsU0FBQyxJQUFEOzBCQUN2QixJQUFJLENBQUUsT0FBTixDQUFjLFlBQWQsRUFBNEIsUUFBNUI7RUFEdUIsQ0ExQ3pCO0VBNkNBLGVBQUEsRUFBaUIsU0FBQTtBQUNmLFFBQUE7SUFBQSxhQUFBLEdBQWdCLElBQUksb0JBQUosQ0FBQTtXQUNoQixhQUFhLENBQUMsTUFBZCxDQUFBO0VBRmUsQ0E3Q2pCO0VBaURBLG9CQUFBLEVBQXNCLFNBQUMsTUFBRDtXQUNwQixTQUFBO2FBQ0UsU0FBQyxJQUFELEVBQU8sTUFBUDtBQUNFLFlBQUE7UUFBQSxPQUFBLEdBQVUsTUFBQSxDQUFPLElBQVA7UUFDVixPQUFBLEdBQVUsT0FBTyxDQUFDLElBQVIsQ0FBQTtRQUNWLElBQUcsT0FBTyxDQUFDLE1BQVIsR0FBaUIsTUFBcEI7VUFDRSxnQkFBQSxHQUFtQixPQUFPLENBQUMsU0FBUixDQUFrQixDQUFsQixFQUFxQixNQUFBLEdBQVMsQ0FBOUIsQ0FBQSxHQUFtQztBQUN0RCxpQkFBTyxlQUFBLEdBQWtCLE9BQWxCLEdBQTRCLElBQTVCLEdBQW1DLGdCQUFuQyxHQUFzRCxVQUYvRDtTQUFBLE1BQUE7QUFJRSxpQkFBTyxRQUpUOztNQUhGO0lBREY7RUFEb0IsQ0FqRHRCO0VBNERBLGdCQUFBLEVBQWtCLFNBQUMsQ0FBRCxFQUFJLEVBQUo7QUFDaEIsUUFBQTtJQUFBLElBQUEsR0FDRTtNQUFBLFFBQUEsRUFBVSxDQUFWO01BQ0EsV0FBQSxFQUFhLEVBRGI7O1dBRUYsV0FBVyxDQUFDLEdBQVosQ0FBZ0Isa0NBQWhCLEVBQW9EO01BQUMsSUFBQSxFQUFNLElBQVA7S0FBcEQ7RUFKZ0IsQ0E1RGxCO0VBa0VBLGVBQUEsRUFBaUIsU0FBQTtJQUNmLG1CQUFBLENBQUE7V0FDQSxnQkFBQSxDQUFBO0VBRmUsQ0FsRWpCO0VBc0VBLG1CQUFBLEVBQXFCLFNBQUE7SUFFbkIsSUFBQSxDQUFPLElBQUksQ0FBQSxTQUFFLENBQUEsV0FBYjtNQUtFLElBQUEsQ0FBTyxJQUFJLENBQUEsU0FBRSxDQUFBLE1BQWI7UUFDRSxJQUFJLENBQUEsU0FBRSxDQUFBLE1BQU4sR0FBZSxTQUFDLEdBQUQ7QUFDYixjQUFBO1VBQUEsQ0FBQSxHQUFJLFNBQUMsQ0FBRCxHQUFBO1VBR0gsSUFBRyxDQUFBLEdBQUksRUFBUDtZQUFlLEdBQUEsR0FBTSxFQUFyQjtXQUFBLE1BQUE7WUFBNEIsRUFBNUI7O2lCQUNELElBQUMsQ0FBQSxjQUFELENBQUEsQ0FBQSxHQUFvQixHQUFwQixHQUEwQixDQUFBLENBQUUsSUFBQyxDQUFBLFdBQUQsQ0FBQSxDQUFBLEdBQWlCLENBQW5CLENBQTFCLEdBQWtELEdBQWxELEdBQXdELENBQUEsQ0FBRSxJQUFDLENBQUEsVUFBRCxDQUFBLENBQUYsQ0FBeEQsR0FBMkUsR0FBM0UsR0FDQSxDQUFBLENBQUUsSUFBQyxDQUFBLFdBQUQsQ0FBQSxDQUFGLENBREEsR0FDb0IsR0FEcEIsR0FDMEIsQ0FBQSxDQUFFLElBQUMsQ0FBQSxhQUFELENBQUEsQ0FBRixDQUQxQixHQUNnRCxHQURoRCxHQUNzRCxDQUFBLENBQUUsSUFBQyxDQUFBLGFBQUQsQ0FBQSxDQUFGLENBRHRELEdBQzRFO1FBTi9ELEVBRGpCOzthQVNBLElBQUksQ0FBQSxTQUFFLENBQUEsV0FBTixHQUFvQixJQUFJLENBQUEsU0FBRSxDQUFBLE9BZDVCOztFQUZtQixDQXRFckI7RUF3RkEsZ0JBQUEsRUFBa0IsU0FBQTtJQUNoQixJQUFHLE9BQU8sTUFBTSxDQUFDLFNBQVMsQ0FBQyxJQUF4QixLQUFnQyxVQUFuQzthQUNFLE1BQU0sQ0FBQyxTQUFTLENBQUMsSUFBakIsR0FBd0IsU0FBQTtlQUN0QixJQUFDLENBQUEsT0FBRCxDQUFTLFlBQVQsRUFBdUIsRUFBdkI7TUFEc0IsRUFEMUI7O0VBRGdCLENBeEZsQjtFQTZGQSxZQUFBLEVBQWMsU0FBQTtJQUNaLElBQUcsMERBQUg7YUFBcUIsS0FBckI7S0FBQSxNQUFBO2FBQStCLE1BQS9COztFQURZLENBN0ZkO0VBZ0dBLEtBQUEsRUFBTyxTQUFDLElBQUQsRUFBTyxJQUFQO0FBQ0wsUUFBQTtJQUFBLE1BQUEsa0JBQVMsSUFBSSxDQUFFLEtBQU4sQ0FBWSxHQUFaO0lBQ1QsTUFBQSxrQkFBUyxJQUFJLENBQUUsS0FBTixDQUFZLEdBQVo7SUFDVCxJQUFBLEdBQU8sQ0FBQyxDQUFDLFVBQUYsQ0FBYSxNQUFiLEVBQXFCLE1BQXJCO1dBQ1AsSUFBSSxDQUFDLE1BQUwsS0FBZTtFQUpWLENBaEdQO0VBc0dBLG1DQUFBLEVBQXFDLFNBQUMsR0FBRCxFQUFNLGFBQU4sRUFBcUIsY0FBckIsRUFBcUMsT0FBckM7QUFDbkMsUUFBQTtJQUFBLGlCQUFBLEdBQW9CO0lBQ3BCLElBQUcsR0FBRyxDQUFDLE9BQUosQ0FBWSxHQUFaLENBQUEsR0FBbUIsQ0FBdEI7TUFDRSxFQUFBLEdBQUssR0FBRyxDQUFDLE9BQUosQ0FBWSxHQUFaO01BQ0wsT0FBQSxHQUFVLEdBQUcsQ0FBQyxTQUFKLENBQWMsR0FBRyxDQUFDLE9BQUosQ0FBWSxHQUFaLENBQWQsRUFBZ0MsR0FBRyxDQUFDLE1BQXBDLEVBRlo7S0FBQSxNQUFBO01BSUUsT0FBQSxHQUFVO01BQ1YsRUFBQSxHQUFLLEdBQUcsQ0FBQyxPQUxYOztJQU1BLFNBQUEsR0FBWSxHQUFHLENBQUMsU0FBSixDQUFjLENBQWQsRUFBaUIsRUFBakI7SUFDWixRQUFBLEdBQVcsU0FBUyxDQUFDLEtBQVYsQ0FBZ0IsR0FBaEI7SUFDWCxjQUFBLEdBQWlCO0lBQ2pCLElBQUcsUUFBUSxDQUFDLE1BQVQsR0FBa0IsQ0FBckI7TUFDRSxVQUFBLEdBQWEsUUFBUyxDQUFBLENBQUEsQ0FBRSxDQUFDLEtBQVosQ0FBa0IsR0FBbEI7TUFDYixDQUFBLEdBQUk7QUFFSixhQUFPLENBQUEsR0FBSSxVQUFVLENBQUMsTUFBdEI7UUFDRSxjQUFBLEdBQWlCLFVBQVcsQ0FBQSxDQUFBLENBQUUsQ0FBQyxLQUFkLENBQW9CLEdBQXBCO1FBQ2pCLElBQUEsQ0FBQSxDQUFPLGlCQUFBLElBQXNCLGNBQWUsQ0FBQSxDQUFBLENBQWYsS0FBcUIsYUFBbEQsQ0FBQTtVQUNFLElBQUcsY0FBQSxLQUFrQixFQUFyQjtZQUNFLGNBQUEsR0FBaUIsSUFEbkI7V0FBQSxNQUFBO1lBR0UsY0FBQSxJQUFrQixJQUhwQjs7VUFJQSxjQUFBLElBQWtCLGNBQWUsQ0FBQSxDQUFBLENBQWYsR0FBb0IsR0FBcEIsR0FBMkIsQ0FBSSxjQUFlLENBQUEsQ0FBQSxDQUFsQixHQUEwQixjQUFlLENBQUEsQ0FBQSxDQUF6QyxHQUFpRCxFQUFsRCxFQUwvQzs7UUFNQSxDQUFBO01BUkYsQ0FKRjs7SUFhQSxJQUF5QixjQUFBLEtBQWtCLEVBQTNDO01BQUEsY0FBQSxHQUFpQixJQUFqQjs7SUFDQSxJQUFHLE9BQUg7TUFDRSxjQUFBLEdBQWlCLEdBQUEsR0FBTSxhQUFOLEdBQXNCLEdBQXRCLEdBQTRCLGNBQTVCLEdBQThDLENBQUksY0FBYyxDQUFDLE1BQWYsR0FBd0IsQ0FBM0IsR0FBa0MsR0FBQSxHQUFNLGNBQWMsQ0FBQyxTQUFmLENBQXlCLENBQXpCLENBQXhDLEdBQXlFLEVBQTFFLEVBRGpFO0tBQUEsTUFBQTtNQUdFLElBQTBCLGNBQUEsS0FBb0IsRUFBcEIsSUFBMkIsY0FBQSxLQUFvQixHQUF6RTtRQUFBLGNBQUEsSUFBa0IsSUFBbEI7O01BQ0EsY0FBQSxJQUFrQixhQUFBLEdBQWdCLEdBQWhCLEdBQXVCLENBQUksY0FBSCxHQUF1QixjQUF2QixHQUEyQyxFQUE1QyxFQUozQzs7V0FLQSxRQUFTLENBQUEsQ0FBQSxDQUFULEdBQWMsY0FBZCxHQUErQjtFQTlCSSxDQXRHckM7RUF1SUEsZUFBQSxFQUFpQixTQUFDLElBQUQ7V0FDZixTQUFBLENBQVUsQ0FBQyxNQUFBLENBQU8sSUFBQSxHQUFPLEdBQVAsR0FBYSxZQUFwQixDQUFpQyxDQUFDLElBQWxDLENBQXVDLFFBQVEsQ0FBQyxNQUFoRCxDQUFBLElBQTJELENBQUMsSUFBRCxFQUFPLElBQVAsQ0FBNUQsQ0FBMEUsQ0FBQSxDQUFBLENBQXBGO0VBRGUsQ0F2SWpCO0VBMElBLDRCQUFBLEVBQThCLFNBQUE7V0FDNUIsSUFBQyxDQUFBLHdCQUFELENBQTBCLHNCQUExQjtFQUQ0QixDQTFJOUI7RUE2SUEsaUNBQUEsRUFBbUMsU0FBQTtXQUNqQyxJQUFDLENBQUEsd0JBQUQsQ0FBMEIsa0JBQTFCO0VBRGlDLENBN0luQztFQWdKQSxpQ0FBQSxFQUFtQyxTQUFBO1dBQ2pDLElBQUMsQ0FBQSx3QkFBRCxDQUEwQixrQkFBMUI7RUFEaUMsQ0FoSm5DO0VBbUpBLGlDQUFBLEVBQW1DLFNBQUE7V0FDaEMsSUFBQyxDQUFBLHdCQUFELENBQTBCLGtCQUExQjtFQURnQyxDQW5KbkM7RUFzSkEsdUJBQUEsRUFBeUIsU0FBQTtXQUN2QixJQUFDLENBQUEsK0JBQUQsQ0FBQSxDQUFBLElBQXNDLElBQUMsQ0FBQSw4QkFBRCxDQUFBO0VBRGYsQ0F0SnpCO0VBeUpBLCtCQUFBLEVBQWlDLFNBQUE7V0FDL0IsSUFBQyxDQUFBLHdCQUFELENBQTBCLGdCQUExQjtFQUQrQixDQXpKakM7RUE0SkEsOEJBQUEsRUFBZ0MsU0FBQTtXQUM5QixJQUFDLENBQUEsd0JBQUQsQ0FBMEIsZUFBMUI7RUFEOEIsQ0E1SmhDO0VBK0pBLHNCQUFBLEVBQXdCLFNBQUE7V0FDdEIsSUFBQyxDQUFBLHdCQUFELENBQTBCLE1BQTFCO0VBRHNCLENBL0p4QjtFQWtLQSx1QkFBQSxFQUF5QixTQUFBO1dBQ3ZCLElBQUMsQ0FBQSx3QkFBRCxDQUEwQixPQUExQjtFQUR1QixDQWxLekI7RUFxS0Esd0JBQUEsRUFBMEIsU0FBQyxTQUFEO0FBQ3hCLFFBQUE7OERBQTRCLENBQUUsbUJBQTlCLEtBQTJDO0VBRG5CLENBcksxQjtFQXdLQSxzQkFBQSxFQUF3QixTQUFBO0FBQ3RCLFFBQUE7OERBQTRCLENBQUUsa0JBQTlCLEtBQTBDO0VBRHBCLENBeEt4QjtFQTJLQSwyQkFBQSxFQUE2QixTQUFDLGNBQUQ7QUFDM0IsUUFBQTs4REFBNEIsQ0FBRSw0QkFBOUIsR0FBbUQ7RUFEeEIsQ0EzSzdCO0VBOEtBLDBCQUFBLEVBQTRCLFNBQUE7V0FDMUIsNEJBQUEsQ0FBQSxDQUFBLElBQWtDLGlDQUFBLENBQUEsQ0FBbEMsSUFBeUUsaUNBQUEsQ0FBQSxDQUF6RSxJQUFnSCxpQ0FBQSxDQUFBO0VBRHRGLENBOUs1QjtFQWlMQSxZQUFBLEVBQWMsU0FBQTtBQU1aLFFBQUE7V0FBQSxNQUFNLENBQUMsZUFBUCx1REFBc0QsQ0FBRSxxQ0FBeEQseURBQW1ILENBQUU7RUFOekcsQ0FqTGQ7RUF5TEEseUNBQUEsRUFBMkMsU0FBQTtXQUN6Qyx3QkFBQSxDQUF5QiwrQkFBekI7RUFEeUMsQ0F6TDNDO0VBNExBLHdCQUFBLEVBQTBCLFNBQUMsVUFBRDtBQUN4QixRQUFBOzRFQUEwQyxDQUFFLFlBQTVDLEtBQWtEO0VBRDFCLENBNUwxQjtFQStMQSxzQkFBQSxFQUF3QixTQUFBO0lBQ3RCLElBQUcsMERBQUg7YUFDRSxDQUFFLENBQUMsQ0FBQyxDQUFDLElBQUYsQ0FBTyxXQUFXLENBQUMsU0FBbkIsQ0FBRCxDQUFBLEdBQStCLEdBQS9CLEdBQWlDLENBQUMsQ0FBQyxDQUFDLElBQUYsQ0FBTyxXQUFXLENBQUMsUUFBbkIsQ0FBRCxDQUFuQyxDQUFrRSxDQUFDLElBQW5FLENBQUEsRUFERjs7RUFEc0IsQ0EvTHhCO0VBbU1BLHNCQUFBLEVBQXdCLFNBQUMsR0FBRDtJQUN0QixHQUFBLEdBQU0sa0JBQWtCLENBQUMsa0NBQW5CLENBQXNELEdBQXREO0lBQ04sR0FBQSxHQUFNLGtCQUFrQixDQUFDLDhCQUFuQixDQUFrRCxHQUFsRDtXQUNOO0VBSHNCLENBbk14QjtFQXdNQSw4QkFBQSxFQUFnQyxTQUFDLEdBQUQ7QUFDOUIsUUFBQTtJQUFBLGNBQUEsR0FBaUIsSUFBQyxDQUFBLFlBQUQsQ0FBQTtJQUNqQixJQUFHLGNBQUg7TUFDRSxHQUFBLEdBQVMsR0FBRCxHQUFLLGtCQUFMLEdBQXVCLGVBRGpDOztXQUVBO0VBSjhCLENBeE1oQztFQThNQSxrQ0FBQSxFQUFvQyxTQUFDLEdBQUQ7QUFDbEMsUUFBQTtJQUFBLG9CQUFBLHFEQUFtRCxDQUFFO0lBQ3JELElBQUcsb0JBQUg7TUFDRSxHQUFBLEdBQVMsR0FBRCxHQUFLLHdCQUFMLEdBQTZCLHFCQUR2Qzs7V0FFQTtFQUprQyxDQTlNcEM7RUFvTkEsc0JBQUEsRUFBeUIsU0FBRSxJQUFGLEVBQVMsR0FBVDtJQUN2QixXQUFXLENBQUMsSUFBSSxDQUFDLFFBQVEsQ0FBQyxJQUExQixHQUFpQztXQUNqQyxhQUFhLENBQUMsY0FBZCxDQUE2QixHQUE3QjtFQUZ1QixDQXBOekI7RUF3TkEseUNBQUEsRUFBMkMsU0FBQyxhQUFEO0FBQ3pDLFFBQUE7SUFBQSxJQUFBLEdBQU87V0FFUCxJQUFJLENBQUMsR0FBTCxDQUFTLFFBQUEsQ0FBUyxhQUFhLENBQUMsU0FBZCxDQUF3QixDQUF4QixFQUEwQixDQUExQixDQUFULEVBQXNDLElBQXRDLENBQVQsRUFBc0QsUUFBQSxDQUFTLGFBQWEsQ0FBQyxTQUFkLENBQXdCLENBQXhCLEVBQTBCLENBQTFCLENBQVQsRUFBdUMsSUFBdkMsQ0FBQSxHQUErQyxDQUFyRyxFQUF1RyxRQUFBLENBQVMsYUFBYSxDQUFDLFNBQWQsQ0FBd0IsQ0FBeEIsRUFBMEIsRUFBMUIsQ0FBVCxFQUF3QyxJQUF4QyxDQUF2RyxFQUFxSixRQUFBLENBQVMsYUFBYSxDQUFDLFNBQWQsQ0FBd0IsRUFBeEIsRUFBMkIsRUFBM0IsQ0FBVCxFQUF5QyxJQUF6QyxDQUFySixFQUFvTSxRQUFBLENBQVMsYUFBYSxDQUFDLFNBQWQsQ0FBd0IsRUFBeEIsRUFBMkIsRUFBM0IsQ0FBVCxFQUF5QyxJQUF6QyxDQUFwTTtFQUh5QyxDQXhOM0M7RUE2TkEsaUJBQUEsRUFBbUIsU0FBQTtBQUNqQixRQUFBO0lBQUEsSUFBQSxHQUFPLE1BQU0sQ0FBQyxRQUFRLENBQUM7SUFDdkIsSUFBRyxJQUFJLENBQUMsT0FBTCxDQUFhLFFBQWIsQ0FBQSxHQUF5QixDQUFDLENBQTdCO2FBQ0UsTUFBTSxDQUFDLFFBQVEsQ0FBQyxNQUFoQixDQUF1QixNQUFBLEdBQU8sSUFBOUIsRUFERjs7RUFGaUIsQ0E3Tm5CO0VBa09BLG9CQUFBLEVBQXNCLFNBQUE7QUFDcEIsUUFBQTtJQUFBLG1CQUFBLEdBQXNCLENBQUEsQ0FBRSxVQUFGO0lBQ3RCLG1DQUFHLG1CQUFtQixDQUFFLGdCQUFyQixHQUE4QixDQUFqQztNQUNFLG1CQUFtQixDQUFDLElBQXBCLENBQUE7YUFDQSxtQkFBbUIsQ0FBQyxRQUFwQixDQUFBLENBQThCLENBQUMsSUFBL0IsQ0FBQSxFQUZGOztFQUZvQixDQWxPdEI7RUF3T0Esb0JBQUEsRUFBc0IsU0FBQTtBQUNwQixRQUFBO0lBQUEsbUJBQUEsR0FBc0IsQ0FBQSxDQUFFLFVBQUY7SUFDdEIsbUNBQUcsbUJBQW1CLENBQUUsZ0JBQXJCLEdBQThCLENBQWpDO01BQ0UsbUJBQW1CLENBQUMsSUFBcEIsQ0FBQTthQUNBLG1CQUFtQixDQUFDLFFBQXBCLENBQUEsQ0FBOEIsQ0FBQyxJQUEvQixDQUFBLEVBRkY7O0VBRm9CLENBeE90QjtFQThPQSxtQkFBQSxFQUFxQixTQUFBO0FBQ25CLFFBQUE7SUFBQSxJQUFHLDRCQUFBLENBQUEsQ0FBQSxJQUFrQyxpQ0FBQSxDQUFBLENBQWxDLElBQ0gsQ0FBQyxpQ0FBQSxDQUFBLENBQUEsSUFBd0MsTUFBQSxDQUFBLENBQXpDLENBREE7TUFFRSxpQkFBQSxHQUFvQixJQUFDLENBQUEsb0JBQUQsQ0FBc0IsT0FBTyxDQUFDLE9BQU8sQ0FBQyxZQUF0Qzt5Q0FDcEIsaUJBQWlCLENBQUUsbUJBSHJCO0tBQUEsTUFBQTtnR0FLd0MsQ0FBRSx1QkFMMUM7O0VBRG1CLENBOU9yQjtFQXNQQSxnQkFBQSxFQUFrQixTQUFDLElBQUQ7V0FDaEIsSUFBQSxLQUFRO0VBRFEsQ0F0UGxCO0VBeVBBLGVBQUEsRUFBaUIsU0FBQyxJQUFEO1dBQ2YsSUFBQSxLQUFRO0VBRE8sQ0F6UGpCO0VBNFBBLGtCQUFBLEVBQW9CLFNBQUMsSUFBRDtXQUNsQixJQUFBLEtBQVE7RUFEVSxDQTVQcEI7RUErUEEsaUJBQUEsRUFBbUIsU0FBQyxLQUFEO0FBQ2pCLFFBQUE7SUFBQSxJQUFBLEdBQ0U7TUFBQSxFQUFBLGtCQUFJLEtBQUssQ0FBRSxXQUFYO01BQ0EsT0FBQSxFQUFTLE1BQU0sQ0FBQyxPQUFPLENBQUMsSUFEeEI7TUFFQSxNQUFBLGtEQUFtQixDQUFFLG9CQUZyQjtNQUdBLE9BQUEsa0JBQVMsS0FBSyxDQUFFLGtCQUhoQjs7SUFJRixJQUFHLE1BQU0sQ0FBQyxZQUFQLENBQUEsQ0FBSDtNQUNFLElBQUksQ0FBQyx1QkFBTCxHQUErQixLQURqQzs7V0FFQTtFQVJpQixDQS9QbkI7RUF5UUEsWUFBQSxFQUFjLFNBQUE7QUFDWixRQUFBO1dBQUEsT0FBTyxDQUFDLE9BQU8sQ0FBQyxnQkFBZ0IsQ0FBQyx5QkFBakMsQ0FBQSxDQUFBLElBQWdFLE1BQU0sQ0FBQyxRQUFQLHlDQUFrQyxDQUFFLDZCQUFwQztFQURwRCxDQXpRZDtFQTRRQSxvQkFBQSxFQUFxQixTQUFBO0FBQ25CLFFBQUE7OERBQTRCLENBQUUsMEJBQTlCLHlEQUE4RSxDQUFFO0VBRDdELENBNVFyQjtFQStRQSxlQUFBLEVBQWdCLFNBQUMsZUFBRDtBQUNkLFFBQUE7SUFBQSxXQUFBLEdBQWM7V0FDZCx5QkFBQSxJQUFxQixDQUFHLENBQUMsQ0FBQyxDQUFDLE9BQUYsQ0FBVSxlQUFlLENBQUMsSUFBaEIsQ0FBcUIsS0FBckIsQ0FBVixDQUFELENBQXhCLElBQXFFLENBQUksV0FBVyxDQUFDLElBQVosQ0FBaUIsZUFBZSxDQUFDLElBQWhCLENBQXFCLEtBQXJCLENBQWpCO0VBRjNELENBL1FoQjtFQW1SQSwwQkFBQSxFQUE0QixTQUFDLGVBQUQsRUFBa0IsdUJBQWxCO0lBQzFCLElBQUcsaUVBQUEsSUFBeUIsQ0FBSSxNQUFNLENBQUMsbUJBQXZDO01BQ0UsTUFBTSxDQUFDLG1CQUFQLEdBQTZCO2FBQzdCLGVBQWUsQ0FBQyxFQUFoQixDQUFtQixNQUFuQixFQUEyQixTQUFBO2VBQUcsdUJBQUEsQ0FBQTtNQUFILENBQTNCLEVBRkY7S0FBQSxNQUdLLElBQU8sK0RBQVA7YUFDSCxNQUFNLENBQUMsbUJBQVAsR0FBNkIsTUFEMUI7O0VBSnFCLENBblI1QjtFQTBSQSxtQkFBQSxFQUFxQixTQUFBO0FBQ25CLFFBQUE7SUFBQSxpQkFBQSxHQUFvQixDQUFBLENBQUUscUNBQUY7V0FDcEIsQ0FBSSxDQUFDLENBQUMsT0FBRixDQUFVLGlCQUFpQixDQUFDLElBQWxCLENBQUEsQ0FBVjtFQUZlLENBMVJyQjtFQThSQSxvQkFBQSxFQUFzQixTQUFDLFlBQUQ7QUFDcEIsUUFBQTttQ0FBQSxZQUFZLENBQUUscUJBQWQsZ0ZBQTRELENBQUU7RUFEMUMsQ0E5UnRCO0VBaVNBLG1CQUFBLEVBQXFCLFNBQUMsUUFBRDtBQUNuQixRQUFBO0lBQUEsUUFBQSxHQUFXO0lBQ1gsSUFBRyxnQkFBSDtNQUNFLENBQUMsQ0FBQyxJQUFGLENBQU8sUUFBUCxFQUFpQixTQUFDLE9BQUQ7UUFDZixJQUFHLE9BQU8sQ0FBQyxZQUFYO1VBQ0UsSUFBRyxPQUFPLENBQUMsWUFBWSxDQUFDLFdBQXJCLENBQUEsQ0FBQSxLQUF3QyxVQUEzQzttQkFDRSxRQUFBLEdBREY7V0FERjs7TUFEZSxDQUFqQixFQURGOztBQU1BLFdBQU87RUFSWSxDQWpTckI7RUEyU0EsMEJBQUEsRUFBNEIsU0FBQTtXQUMxQixRQUFBLDhEQUFTLFdBQVcsQ0FBRSxvQ0FBdEIsQ0FBQSxJQUF1RCxDQUFJLE1BQU0sQ0FBQyxvQkFBUCxDQUFBO0VBRGpDLENBM1M1QjtFQThTQSx5QkFBQSxFQUEyQixTQUFBO1dBQ3pCLFFBQUEsOERBQVMsV0FBVyxDQUFFLG9DQUF0QixDQUFBLElBQXVELENBQUksTUFBTSxDQUFDLG9CQUFQLENBQUE7RUFEbEMsQ0E5UzNCO0VBaVRBLGVBQUEsRUFBaUIsU0FBQTtXQUNmLE1BQU0sQ0FBQyxZQUFQLENBQW9CLENBQUEsQ0FBRSx1QkFBRixDQUFwQjtFQURlLENBalRqQjtFQW9UQSxlQUFBLEVBQWlCLFNBQUE7V0FDZixNQUFNLENBQUMsWUFBUCxDQUFvQixDQUFBLENBQUUsdUJBQUYsQ0FBcEI7RUFEZSxDQXBUakI7RUF1VEEsNEJBQUEsRUFBOEIsU0FBQTtXQUM1QixNQUFNLENBQUMsUUFBUCxDQUFnQixXQUFXLENBQUMsdUNBQTVCLENBQUEsSUFBeUUsT0FBTyxDQUFDLE9BQU8sQ0FBQyxnQkFBZ0IsQ0FBQywrQkFBakMsQ0FBQTtFQUQ3QyxDQXZUOUI7RUEwVEEsMkJBQUEsRUFBNkIsU0FBQTtBQUMzQixRQUFBO0lBQUEsUUFBQSwrRkFBeUQsQ0FBRSxXQUFoRCxDQUFBLG9CQUFBLElBQWlFO0lBQzVFLFdBQUEsb0dBQStELENBQUUsV0FBbkQsQ0FBQSxvQkFBQSxJQUFvRTtJQUNsRixjQUFBLG1GQUFpRCxDQUFFLFdBQWxDLENBQUEsb0JBQUEsSUFBbUQ7SUFDcEUsaUJBQUEsc0ZBQXVELENBQUUsV0FBckMsQ0FBQSxvQkFBQSxJQUFzRDtXQUMxRSxrQkFBQSxJQUFjLENBQUMsUUFBUSxDQUFDLE9BQVQsQ0FBaUIsY0FBakIsQ0FBQSxHQUFtQyxDQUFDLENBQXJDLENBQWQsSUFBMEQscUJBQTFELElBQTJFLENBQUMsV0FBVyxDQUFDLE9BQVosQ0FBb0IsaUJBQXBCLENBQUEsR0FBeUMsQ0FBQyxDQUEzQztFQUxoRCxDQTFUN0I7OztBQWlVRixNQUFNLENBQUMsT0FBUCxHQUFpQiJ9
